/** @type {import('../help-index.js').HelpSidebarItem} */
export const TAX_PER_CONFIG_ITEM = {
  id: 'perception_config',
  screenId: 'tax-per-config',
  label: 'Configuración',
  description: 'Qué impuestos percibís al facturar y bajo qué condiciones.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Si sos agente de percepción, configurás acá qué impuestos el sistema calcula automáticamente en las facturas de venta (IIBB, sellos, etc.) según el cliente, su condición de IVA y la provincia.',
      },
      {
        title: 'Antes de empezar',
        paragraphs: [
          'El impuesto debe existir en Impuestos → Configuración y tener marcado «Permite retención al cobrar».',
        ],
      },
      {
        title: 'Paso 1 — Ver el listado',
        bullets: [
          'Interruptor «Solo activos».',
          'Columnas: Impuesto, Mín. imponible, IVA aplicable, Provincias, Activo.',
          'Tocá una fila para editar. Botón + para nueva configuración.',
        ],
      },
      {
        title: 'Paso 2 — Nueva configuración',
        fields: [
          { label: 'Impuesto', description: 'Impuesto que vas a percibir como agente.' },
          { label: 'Mínimo imponible', description: 'Importe mínimo de la base para que aplique la percepción (≥ 0).' },
          { label: 'Condiciones de IVA', description: 'Marcá al menos una (Responsable inscripto, Monotributo, etc.). Solo a esos clientes se les percibe.' },
          { label: 'Provincias', description: 'Opcional. Si no marcás ninguna, aplica en todas las provincias configuradas.' },
        ],
      },
      {
        title: 'Paso 3 — Editar o desactivar',
        paragraphs: [
          'Podés ajustar mínimo, condiciones IVA, provincias y activo. «Desactivar» deja de percibir ese impuesto en nuevas facturas.',
        ],
      },
    ],
  },
}
